import { render, staticRenderFns } from "./Template6.vue?vue&type=template&id=903ac3aa&scoped=true"
import script from "./Template6.vue?vue&type=script&lang=js"
export * from "./Template6.vue?vue&type=script&lang=js"
import style0 from "./Template6.vue?vue&type=style&index=0&id=903ac3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903ac3aa",
  null
  
)

export default component.exports